import { useEffect } from "react";
import type { FilterWidgetSettings } from "../../../../../../api/types/dashboardsTypes";
import { ReferenceDateType } from "../../../../../../api/types/dashboardsTypes";
import ReferenceDatePicker from "./ReferenceDatePicker";

interface Props {
  settings: FilterWidgetSettings;
  onSettingsChange: (settings: Partial<FilterWidgetSettings>) => void;
}

const DateDropdown = ({ settings, onSettingsChange }: Props) => {
  const handleOnChange = (referenceDate: ReferenceDateType, customValue: string[]) => {
    onSettingsChange({
      referenceDate,
      defaultValue: customValue,
    });
  };

  useEffect(() => {
    if (settings.referenceDate === undefined) {
      onSettingsChange({
        defaultValue: [],
        referenceDate: ReferenceDateType.ThisMonth,
      });
    }
  }, [settings, onSettingsChange]);

  return (
    <ReferenceDatePicker
      valueType={settings.referenceDate || ReferenceDateType.ThisMonth}
      customValue={settings.defaultValue as string[]}
      onChange={handleOnChange}
    />
  );
};

export default DateDropdown;
